export default "__VITE_ASSET__29b27a37__"